export default (value, minLength, maxLength) => value.length >= minLength && (!maxLength || value.length <= maxLength);
